module.exports = __webpack_public_path__ + "img/LV21.7aa9265b.png";